<template>
    <FilterModal :type="selectedIntegrationCodes.length === 0 ? 'btn-danger' : null"
                  :filterable="__('general.integrations')"
                  :value="selectedIntegrationCodes.length"
    >
        <div v-for="integration in salesChannelIntegrations" :key="integration.code">
            <Checkbox v-model="selection[integration.code]">
                {{ integration.name }}
            </Checkbox>
        </div>
    </FilterModal>
</template>

<script>
import FilterModal from "@components/Stats/FilterModal.vue";
import Checkbox from "@components/Form/Checkbox.vue";

export default {
    components: {Checkbox, FilterModal},

    props: {
        salesChannelIntegrations: Array,
        value: Object
    },

    data() {
        return {
            selection: this.value
        }
    },

    computed: {
        selectedIntegrationCodes() {
            let integrationCodes = [];

            for (let integrationCode in this.selection) {
                if (this.selection[integrationCode]) {
                    integrationCodes.push(integrationCode);
                }
            }

            return integrationCodes;
        }
    },

    watch: {
        selection(newValue, oldValue) {
            this.$emit('input', newValue)
        }
    }
}
</script>
